function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 1.6665C5.4 1.6665 1.66666 5.39984 1.66666 9.99984C1.66666 14.5998 5.4 18.3332 10 18.3332C14.6 18.3332 18.3333 14.5998 18.3333 9.99984C18.3333 5.39984 14.6 1.6665 10 1.6665ZM10 16.6665C6.31666 16.6665 3.33333 13.6832 3.33333 9.99984C3.33333 8.45817 3.85833 7.0415 4.74166 5.9165L14.0833 15.2582C12.9583 16.1415 11.5417 16.6665 10 16.6665ZM15.2583 14.0832L5.91666 4.7415C7.04166 3.85817 8.45833 3.33317 10 3.33317C13.6833 3.33317 16.6667 6.3165 16.6667 9.99984C16.6667 11.5415 16.1417 12.9582 15.2583 14.0832Z"
});

var SvgCannotVote = function SvgCannotVote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCannotVote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cannot-vote.701a5555.svg";
export { ForwardRef as ReactComponent };